module.exports = __webpack_public_path__ + "img/Banner_Escut.31ac9500.jpg";